export default "__VITE_ASSET__ktlnBFb4__"